import * as React from "react";
import { connect } from "react-redux";

import { IState } from "../../classes/state";

export class CalendarDataTestingContainer extends React.Component<any, any> {

  public constructor(props: any, context: any) {
    super(props, context);
  }

  public render() {

    const divStyle = {
      backgroundColor: "white",
      border: "3px solid black",
      bottom: "10px",
      height: "500px",
      left: "10px",
      margin: "0px",
      overflow: "auto",
      padding: "10px",
      textAlign: "left" as "left",
      width: "100%",
      zIndex: 100000,
    };

    const trimmedEvents = this.props.theState.events.map((e) => this.pick(e, "isAllDay", "localStartDate", "localEndDate", "name"));

    const dateState = {
      calendarSettings: this.pick(this.props.theState.calendarSettings, "action", "currentDate", "iCalStartDate", "firstDayOfWeek", "localFromDate", "localToDate", "selectedDate", "todaysDate", "userDateFormat", "viewMode"),
      events: trimmedEvents,
      numAjaxCallsInProgress: this.props.theState.numAjaxCallsInProgress,
    };

    return (
      <div style={divStyle} >
        <p>All dates listed below are set to the user's local time, but stored in UTC time Zone. Try setting your local computer time zone to +0 (UTC time) to see the local dates and
          the dates localised by your browser matching. When you change your local computer's time zone from UTC, <b>all</b> the dates below should shift by the offset amount, but remain relatively unchanged from each other.</p>
        <h2>Just Date Data in the State:</h2>
        <pre>{JSON.stringify(dateState, null, 4)}</pre>
        <h2>Entire State:</h2>
        <pre>{JSON.stringify(this.props.theState, null, 4)}</pre>
      </div>
    );
  }

  private pick = (o, ...props) => {
    return Object.assign({}, ...props.map((prop) => ({ [prop]: o[prop] })));
  }

}

const mapStateToProps = (state: IState, ownProps: any) => { // 'state' is the state in our Redux Store; 'ownProps' is a reference to this component's own this.props.
  return {
    theState: state,
  };
};

export default connect(mapStateToProps)(CalendarDataTestingContainer);
